import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  position: relative;
  height: ${(p) => p.$height || '220px'};
  background: linear-gradient(145deg, #0e6b3c 0%, #1e3a5f 50%, #0f172a 100%);
  overflow: hidden;
`;

const Chrome = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .dots {
    display: flex;
    gap: 5px;
    span {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      &:nth-child(1) {
        background: #f87171;
      }
      &:nth-child(2) {
        background: #fbbf24;
      }
      &:nth-child(3) {
        background: #4ade80;
      }
    }
  }

  .url {
    flex: 1;
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.7);
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 4px 10px;
    font-family: ui-monospace, monospace;
  }
`;

const Body = styled.div`
  padding: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  height: ${(p) => (p.$frameless ? '100%' : 'calc(100% - 37px)')};
`;

const Stat = styled.div`
  padding: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.12);

  strong {
    display: block;
    font-family: var(--font-display);
    font-size: 1.1rem;
    font-weight: 800;
    color: #fff;
  }

  span {
    font-size: 0.62rem;
    color: rgba(255, 255, 255, 0.75);
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

const Wide = styled.div`
  grid-column: 1 / -1;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(109, 187, 26, 0.2);
  border: 1px solid rgba(109, 187, 26, 0.35);
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    color: #6dbb1a;
    font-size: 1rem;
  }

  p {
    margin: 0;
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.4;
  }
`;

const LmsPreviewMock = ({ height, domain = 'lms.rhutechsolutions.com', frameless = false }) => (
  <Wrap $height={height}>
    {!frameless && (
      <Chrome>
        <div className="dots">
          <span /><span /><span />
        </div>
        <div className="url">{domain}</div>
      </Chrome>
    )}
    <Body $frameless={frameless}>
      <Stat>
        <strong>24</strong>
        <span>Tests taken</span>
      </Stat>
      <Stat>
        <strong>8</strong>
        <span>Courses</span>
      </Stat>
      <Stat>
        <strong>5</strong>
        <span>Certificates</span>
      </Stat>
      <Stat>
        <strong>1.2k</strong>
        <span>XP earned</span>
      </Stat>
      <Wide>
        <i className="fas fa-robot" />
        <p>AI study plan ready — Analytics & live classes</p>
      </Wide>
    </Body>
  </Wrap>
);

export default LmsPreviewMock;
